import { PAYMENT_METHODS } from 'config/app-config';
import { NsAlert } from 'components/common/ns-alert/NsAlert';
import { NsCaveatLink } from 'components/common/ns-caveat-link/NsCaveatLink';
import { useDDSavingsAmount } from 'hooks/useDDSavingsAmount';
export const checkAlertTestId = 'checkAlertTestId';

type DirectDebitSavingsProps = {
  paymentMethod: typeof PAYMENT_METHODS[keyof typeof PAYMENT_METHODS];
};

export const DirectDebitSavings = ({
  paymentMethod
}: DirectDebitSavingsProps) => {
  const { savingsAmount, priceCapDate } = useDDSavingsAmount();
  const isCheck = paymentMethod === PAYMENT_METHODS.CHECK;

  if (!isCheck) return null;

  return (
    <NsAlert
      state="info"
      heading="Save money with a Direct Debit"
      testId={checkAlertTestId}
    >
      <p>
        You could save <b>{savingsAmount} per year</b> on your bill when you pay
        by Direct Debit, compared to paying by card, cash or cheque every three
        months.
        <NsCaveatLink>
          Cash, card or cheque extra spend based on a dual fuel customer with an
          average consumption of 11,500 kWh for gas and 2,700 kWh for
          single-rate electricity at {priceCapDate} energy price cap rates.
        </NsCaveatLink>
      </p>
    </NsAlert>
  );
};
